import React from "react";
import { homeExperienceData } from "../../fourthUtils/constant";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Experience = (props) => {
    const { language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1
    });

    return (
        <div className={"frth-design-experience-main"} ref={ref}>
            <div className="frth-design-experience-inner">
                {homeExperienceData?.map((v, i) => (
                    <div key={i}>
                        <div>
                            <button>{v?.icon}</button>
                        </div>
                        <div className="frth-design-exp-text">
                            <h1>
                                {inView && (
                                    <CountUp
                                        start={0}
                                        end={v?.quantity}
                                        duration={5}
                                    />
                                )}
                            </h1>
                            <p>
                                {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Experience;
